import React, { Fragment, useState, useEffect } from "react";
import {
  Card,
  Select,
  Button,
  Dropdown,
  Menu,
  Affix,
  Popconfirm,
  Typography,
  Breadcrumb,
  Input,
  Space,
} from "antd";
import ListTable from "../../../common/ListTable";
import Header from "../../Common/Header";
import { isMobileView } from "../../Common/AppHelper";
import { Link, useLocation } from "react-router-dom";
import { MoreOutlined, EditOutlined, DeleteTwoTone, EyeOutlined } from "@ant-design/icons";
import {
    WEEKENDS
} from "../../../apiServices/API_ENDPOINTS";
import { getData, deleteData, postData } from "../../../apiServices/common";
import CustomFilter from "../../Common/CustomFilter";
import { alertPop } from "../../../apiServices/common/helper";
import { cglFormatDate, commaSeparateNumber, hasPermission } from "../../../utils/functions";
import { NO_PERMISSION_REQUIRED } from "../../../routes/permissions";
import moment from "moment";

const Weekends = (props) => {
  // Props
  const { width } = props;

  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  //   States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );

  const [weekendList, setWeekendList] = useState(null);
  const [totalData, setTotalData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rangeData, setRangeData] = useState();
  const [fetchError, setFetchError] = useState(null);

  // Antd
  const { Title } = Typography;

  // Filter open/close status update in localStorage
  // useEffect(() => {
  //   const filterStatus = localStorage.getItem("filter_status");
  //   const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

  //   if (showFilter) {
  //     parsedFilterStatus[routerPath] = true;
  //     localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
  //   } else {
  //     parsedFilterStatus[routerPath] = false;
  //     localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
  //   }
  // }, [showFilter, routerPath, location]);

  const columns = [
    {
      title: "Effective Date",
      dataIndex: "effective_date",
      key: "effective_date",
      render: (value, record) => {
        return(
          <div>
            {cglFormatDate(value)}
          </div>
        )
      }
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      render: (value, record) => {
        const day = record.days[record.days.length - 1]?.target_date
        return(
          <div>
            {cglFormatDate(day)}
          </div>
        )
      }
    },
    {
      title: "Entry Date",
      dataIndex: "entry_date",
      key: "entry_date",
      render: (value, record) => {
        return(
          <div>
             {cglFormatDate(value)}
          </div>
        )
      }
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <div className="cursore-pointer">
          <Dropdown overlay={menu(record)}>
            <MoreOutlined style={{ fontSize: "20px" }} />
          </Dropdown>
        </div>
      ),
    },
  ];

  const getAllSlug = async (filterValues) => {
    setLoading(true);
    setFetchError(null);

    const bodyData = filterValues;
    const response = await getData(WEEKENDS, false, bodyData);
    console.log('filterValues', filterValues);
    console.log('response', response);
    if (response && response?.data?.code === 200) {
      
      setWeekendList(response?.data?.data?.data);
      setTotalData(response?.data?.data?.total);
      setRangeData(response?.data?.data?.per_page);
    } else {
      alertPop(
        "error",
        response?.messages ? response?.messages : "Something Went Wrong!",
      );
      setFetchError("Could not load this list.");
    }

    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getAllSlug({page: currentPage});
  }, [currentPage]);

  const removeWeekend = async (value) => {
    const response = await deleteData(`${WEEKENDS}/${value}`);
    if (response && response?.code === 200) {
      alertPop("success", "Deleted Successfully!");
      getAllSlug({page: currentPage});
    } else {
      alertPop(
        "error",
        response?.data?.message
          ? response?.data?.message[0]
          : "Something Went Wrong!",
      );
    }
  };

  const menu = (data) => (
    <Menu
      items={[
        {
          label: (
            <Link to={`/production-planning/weekend-update/${data.id}`}>
              <EditOutlined /> Edit
            </Link>
          ),
          key: "0",
          disabled: !hasPermission([NO_PERMISSION_REQUIRED]),
        },
        {
          label: (
            <Popconfirm
              title="Are you sure you want to delete?"
              onConfirm={() => removeWeekend(data.id)}
            >
              <DeleteTwoTone /> Delete
            </Popconfirm>
          ),
          key: "2",
          disabled: !hasPermission([NO_PERMISSION_REQUIRED]),
        },
      ]}
    />
  );

  const paginate = (page) => {
    setCurrentPage(page);
  };

  // const handleFilter = () => {
  //   setShowFilter((prev) => !prev);
  // };

  const extra = (
    <Space>
      {/* <Button
        type={showFilter ? "danger" : "primary"}
        size="small"
        onClick={() => setShowFilter((prev) => !prev)}
        style={{ float: "right" }}
      >
        {`${showFilter ? "Close" : "Open"} Filter Option`}
      </Button> */}
      <Button key="3" size="small" type="primary">
        <Link to="/production-planning/weekends/create">Add New</Link>
      </Button>
    </Space>
  );

  return (
    <Fragment>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={<Title level={5}>Weekends</Title>}
            actions={extra}
          />
        </Card>
      </Affix>

      <div className="containt-body">
        <Card>
          {/* <CustomFilter
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            tableData={weekendList}
            fetchTableData={getAllSlug}
            filterName="notification_slugs"
            // filterName="cost_estimate"
          /> */}
          <ListTable
            loading={loading}
            error={fetchError}
            onRetry={() => getAllSlug({ page: currentPage })}
            emptyText="No records to show yet."
            dataSource={weekendList}
            columns={columns}
            pagination={{
              showSizeChanger: false,
              current: currentPage,
              total: totalData,
              pageSize: rangeData,
              onChange: (page) => paginate(page),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Card>
      </div>
    </Fragment>
  );
};

export default Weekends;
